<ng-template #breadcrumbAction>
    <a class="btn btn-primary" routerLink="/orders/new" role="button">{{ 'order.new' | translate }}</a>
</ng-template>

<ui-page title="Dashboard" [card]="false" [breadcrumbAction]="breadcrumbAction">
    <div class="row">
        <div class="col-lg-8">
            <div class="card">
                <div class="card-header p-pb-0">
                    <div class="d-flex justify-content-between">
                        <div>
                            <h4 class="card-title mb-0">Prehľad objednávok</h4>
                            <div class="small text-muted">Posledných 12 mesiacov</div>
                        </div>
                        <div
                            class="btn-toolbar d-none d-md-block"
                            role="toolbar"
                            aria-label="Toolbar with buttons"
                        ></div>
                    </div>
                </div>
                <div class="card-body">
                    <p-chart type="line" [data]="data" [options]="options"></p-chart>
                </div>
            </div>
        </div>

        <div class="col-md-6 col-lg-4">
            <div class="card">
                <div class="card-header p-pb-0">
                    <div class="d-flex justify-content-between">
                        <div>
                            <h4 class="card-title mb-0">{{ 'tasklist' | translate }}</h4>
                            <!--TODO maybe count <div class="small text-muted">Poslednych 12 mesiacov</div> -->
                        </div>
                        <div class="p-field p-fluid" style="min-width: 200px">
                            <p-calendar
                                [(ngModel)]="tasklistDateRange"
                                selectionMode="range"
                                (ngModelChange)="reloadTasklist()"
                                [readonlyInput]="true"
                                inputId="range"
                            ></p-calendar>
                        </div>
                    </div>
                </div>
                <div class="card-body" *ngIf="tasklist">
                    <div class="task" *ngIf="!tasklist.items || tasklist.items.length == 0" style="margin: 0">
                        <a href="" class="task-title">{{ 'tasklist.noitems' | translate }}</a>
                    </div>
                    <div
                        class="d-flex justify-content-between p-py-2"
                        *ngFor="let item of tasklist.items"
                        style="margin: 0"
                    >
                        <span href="" class="task-title"
                            ><b>{{ item.analysis }}</b> <span> </span>
                        </span>
                        <span class="badge badge-success p-p-1" [ngPlural]="item.samples.length">
                            <ng-template ngPluralCase="=0">0 Vzoriek</ng-template>
                            <ng-template ngPluralCase="=1">1 vzorka</ng-template>
                            <ng-template ngPluralCase="few">{{ item.samples.length }} vzorky</ng-template>
                            <ng-template ngPluralCase="other">{{ item.samples.length }} vzoriek</ng-template>
                        </span>
                    </div>
                    <!-- / .task -->
                </div>
                <!-- / .panel-body -->
                <div class="card-footer">
                    <div class="f-right">
                        <div class="btn-group">
                            <!-- <button type="button" class="btn btn-info" (click)="print('small')">
                                {{ 'tasklist.small' | translate }}&nbsp;<span></span>
                            </button> -->
                            <button
                                type="button"
                                class="btn btn-info"
                                (click)="print('big')"
                                ngxPrint
                                printSectionId="tasklist-big"
                                [useExistingCss]="true"
                            >
                                {{ 'tasklist.print' | translate }}&nbsp;{{ 'tasklist.big' | translate }}&nbsp;
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div id="tasklist-big" class="print-only" *ngIf="tasklist">
        <style>
            .gt-ie8 input.px + .lbl:before {
                width: 20px;
                height: 20px;
            }
        </style>
        <h2>
            {{ 'tasklist' | translate }} <strong>{{ tasklistDateRange[0] | date: 'd.M.yyyy' }}</strong> -
            <strong>{{ tasklistDateRange[1] | date: 'd.M.yyyy' }}</strong>
        </h2>

        <div class="panel" *ngFor="let item of tasklist.items" style="page-break-inside: avoid">
            <div class="panel-heading">
                <span class="panel-title"
                    ><b>{{ item.analysis }} </b> ({{ item.samples.length }})</span
                >
            </div>
            <div class="panel-body print-compact" style="padding-bottom: 0">
                <table class="table table-condensed no-outer-border" style="margin-bottom: 0">
                    <thead>
                        <tr>
                            <th>{{ 'Hotové' }}</th>
                            <th>{{ 'sample.labCode' | translate }}</th>
                            <th>{{ 'sample.receiptDate' | translate }}</th>
                            <th>{{ 'order.id' | translate }}</th>
                            <th>{{ 'order.note' | translate }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let sample of item.samples" style="page-break-inside: avoid">
                            <td>
                                <label class="px-single"
                                    ><input type="checkbox" name="" value="" class="px" /><span class="lbl"></span
                                ></label>
                            </td>
                            <td>{{ sample.labCode }}</td>
                            <td>{{ sample.receivedDate | date: 'd.M.yyyy' }}</td>
                            <td>{{ sample.orderId }}</td>
                            <td></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</ui-page>
